<div class="modal-header">
  <span class="pull-right">
    <button class="btn btn-default btn-xs" (click)="closeModal()">
      <i class="glyphicon glyphicon-remove"></i>
    </button>
  </span>
  <span>
    <h4 class="modal-title">{{ request.title }}</h4>
  </span>
</div>

<div class="modal-body" [formGroup]="assignmentForm">
  <div class="form-horizontal">
    <div
      class="form-group"
      [class.has-error]="assignmentForm.get('tacticalLiaison').errors"
    >
      <label class="control-label col-sm-4">Tactical Liaison</label>
      <div class="col-sm-8">
        <select class="form-control" formControlName="tacticalLiaison">
          <option [ngValue]="null"></option>
          <option *ngFor="let liaison of tacticalLiaisons" [value]="liaison.id">
            {{ liaison.givenName }} {{ liaison.surname }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-danger" (click)="closeModal()">Cancel</button>
  <button
    class="btn btn-primary"
    (click)="reAssignRequest()"
    [disabled]="assignmentForm.invalid"
  >
    Re-assign
  </button>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-reassignment-modal/request-reassignment-modal.component.html